module.exports = __webpack_public_path__ + "static/assets/3c5ea9351a72a2ee6039f3d5a6e688e1.svg";